import { useSnackbar } from 'notistack';
import { Box, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { Panel } from 'primereact/panel';

import { useCreateOrgao1Mutation, useCreateOrgaoMutation, useGetOrgaoQuery } from './orgaoApiSlice';
import errorFormat from '../../utils/errorFormat';
import { useNavigate, useParams } from 'react-router-dom';
import configUrls from '../../config/configUrls';
import { ISorgao, Orgao } from '../../types/orgao/Orgao';
import { OrgaoForm } from './OrgaoForm';

import { AxiosError } from 'axios';
import { ErrorMessage } from '../../types/ErrorMessage';
import axiosInstance from '../../app/axiosInstance';
import { skipToken } from '@reduxjs/toolkit/query';
import { useOrgaoRoutes } from '../../config/useOrgaoRoutes';

export const OrgaoCreate = () => {
  const orgaoRoutes = useOrgaoRoutes();
  const [orgao, setOrgao] = useState<Orgao>(ISorgao);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createOrgao, status] = useCreateOrgao1Mutation();
  const navigate = useNavigate();
  const [imagemCapa, setImagemCapa] = useState<File | null>(null); //passar o estado para o form
  const [loading, setLoading] = useState(false);

  const id = useParams().id || '';
  const { data, isFetching, error } = useGetOrgaoQuery(id || skipToken, { refetchOnMountOrArgChange: true });
  useEffect(() => {
    if (data) {
      setOrgao(data);
    } else if (error) {
      enqueueSnackbar('Registro não encontrado!', { variant: 'error' });
    } else if (isFetching) {
      enqueueSnackbar('Buscando registro...', { variant: 'info' });
    } else {
      enqueueSnackbar('Registro não encontrado!', { variant: 'error' });
    }
  }, [data, error, isFetching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    setOrgao(prev => ({
      ...prev,
      [name]: value.toUpperCase()
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  const handleCepChange = (newCep: string) => {
    // Aqui você pode atualizar o estado com o novo valor de CEP
    setOrgao(prev => ({
      ...prev,
      cep: newCep
    }));
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const formData = new FormData();

    //noticiaAnexoParaSalvar.forEach((imagem) => {
    //    formData.append('imagens', imagem);
    //});

    if (imagemCapa) {
      formData.append('anexo', imagemCapa);
    }

    formData.append('orgaojson', JSON.stringify(orgao)); // Anexa os dados da publicação como JSON
    //formData.append('anexosJaSalvos', JSON.stringify(noticiaAnexoSalvo)); // salvo a lista de anexo para saber se algum foi deletado

    try {
      setLoading(true);
      const response = await axiosInstance.post(orgaoRoutes.ORGAO_API_EP_AXIOS, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      enqueueSnackbar('Registro salvo com sucesso!', { variant: 'success' });
      navigate(-1);
    } catch (error) {
      const axiosError = error as AxiosError;

      enqueueSnackbar('Erro ao gravar o registro. Tente novamente mais tarde', { variant: 'error' });

      let erro: undefined | ErrorMessage;
      if (axiosError.response) {
        erro = axiosError.response.data as ErrorMessage;
      }
      if (erro && erro?.message) {
        enqueueSnackbar(erro.message, { variant: 'error' });
      } else {
        enqueueSnackbar('Mensagem de erro não disponível', { variant: 'error' });
      }
    } finally {
      setLoading(false);
    }

    //await createOrgao(orgao);
  }

  return (
    <>
      <Paper>
        <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
          Orgão de governo
        </Typography>

        <OrgaoForm
          data={orgao}
          // isdisabled={status.isLoading}
          //isLoading={status.isLoading}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          handleCepChange={handleCepChange}
          setLogo={setImagemCapa}
          logo={imagemCapa}
          isLoading={loading}
        />
      </Paper>
    </>
  );
};
